module.exports = __webpack_public_path__ + "img/title2.2aa52f28.png";